var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h100vh-100",attrs:{"id":"trackTable"}},[_c('MonitTableMenu',{on:{"methodEnum":_vm.methodEnum}}),_c('MonitTable',{ref:"monitTable"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }